<nz-drawer [nzBodyStyle]="{ overflow: 'auto' }" [nzMaskClosable]="false" [nzWidth]="850" nzCentered
    [nzVisible]="isVisibleUserDrawer" [nzTitle]="userDrawerTitle" [nzFooter]="footerTpl" (nzOnClose)="handleCancel()">
    <ng-container *nzDrawerContent>
        <form nz-form [formGroup]="_fS.userForm">
            <div nz-row [nzGutter]="{ xs: 8, sm: 16, md: 15, lg: 15 }">
                <div nz-col nzXs="24" nzSm="12" nzMd="12" nzLg="12" nzXl="12">
                    <nz-form-item>
                        <nz-form-control [nzErrorTip]="firstNameError">
                            <label class="label-text required">First name</label>
                            <input class="input-group" nz-input formControlName="firstName"
                                (keypress)="_cS.checkAlphabetsWithSpace($event)" minlength="2" maxlength="100"
                                placeholder="Enter first name" />
                            <ng-template #firstNameError let-control>
                                <ng-container *ngIf="control.hasError('required')">Please enter first
                                    name</ng-container>
                                <ng-container *ngIf="control.hasError('minlength')">First name
                                    {{validationMessage.minlength}}
                                </ng-container>
                            </ng-template>
                        </nz-form-control>
                    </nz-form-item>
                </div>
                <div nz-col nzXs="24" nzSm="12" nzMd="12" nzLg="12" nzXl="12">
                    <nz-form-item>
                        <nz-form-control [nzErrorTip]="lastNameError">
                            <label class="label-text required">Last name</label>
                            <input class="input-group" nz-input formControlName="lastName"
                                (keypress)="_cS.checkAlphabetsWithSpace($event)" minlength="2" maxlength="100"
                                placeholder="Enter last name" />
                            <ng-template #lastNameError let-control>
                                <ng-container *ngIf="control.hasError('required')">Please enter last name</ng-container>
                                <ng-container *ngIf="control.hasError('minlength')">Last name
                                    {{validationMessage.minlength}}
                                </ng-container>
                            </ng-template>
                        </nz-form-control>
                    </nz-form-item>
                </div>
                <div nz-col nzXs="24" nzSm="12" nzMd="12" nzLg="12" nzXl="12">
                    <nz-form-item>
                        <nz-form-control [nzErrorTip]="emailAddressError">
                            <label class="label-text required">Email address</label>
                            <input class="input-group" type="text" nz-input formControlName="emailAddress"
                                placeholder="Enter email address" />
                            <ng-template #emailAddressError let-control>
                                <ng-container *ngIf="control.hasError('required')">Please enter email address
                                </ng-container>
                                <ng-container *ngIf="control.hasError('pattern')">Enter valid email address
                                </ng-container>
                            </ng-template>
                        </nz-form-control>
                    </nz-form-item>
                </div>
                <div nz-col nzXs="24" nzSm="12" nzMd="12" nzLg="12" nzXl="12"
                    *ngIf="currentSelectedTab != UserTypes.Supplier">
                    <nz-form-item>
                        <nz-form-control [nzErrorTip]="roleError">
                            <label class="label-text required">Role</label>
                            <nz-select nzShowSearch nzPlaceHolder="Select role" [nzSize]="'default'"
                                [nzDisabled]="selectedData && selectedData.roles == 'Super Admin'"
                                formControlName="role" (ngModelChange)="checkIfPayBevRole($event)"
                                [nzSelectOnTab]="true">
                                <nz-option *ngFor="let option of listOfRoles" [nzLabel]="option.name"
                                    [nzValue]="option.id"></nz-option>
                            </nz-select>
                            <ng-template #roleError let-control>
                                <ng-container *ngIf="control.hasError('required')">Please select role</ng-container>
                            </ng-template>
                        </nz-form-control>
                    </nz-form-item>
                </div>
                <div nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="12" nzXl="12"
                    *ngIf="currentSelectedTab == UserTypes.Operator">
                    <nz-form-item class="mb-0 d-flex align-i-c">
                        <nz-form-control class="switch-box enable-switch">
                            <nz-switch formControlName="is2FArequired" (ngModelChange)="checkIf2FAEnabled($event)">
                            </nz-switch>
                            <label class="switch-label black mr-1">Enable 2FA</label>
                        </nz-form-control>
                    </nz-form-item>
                </div>
                <!--(paste)="_cS.checkNumbers($event)"-->
                <!-- <div nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="12" nzXl="12"*ngIf="show2FAToggle || currentSelectedTab == UserTypes.Operator"> -->
                <div nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="12" nzXl="12">
                    <nz-form-item>
                        <nz-form-control [nzErrorTip]="phoneError">
                            <label class="label-text" [ngClass]="this.isTwoFA? 'required' : ''">Phone number</label>
                            <nz-input-group>
                                <input #phoneNumberField class="input-group" nz-input formControlName="phoneNumber"
                                    (keypress)="_cS.checkNumbers($event)" mask="(000) 000-0000"
                                    placeholder="Enter phone number">
                            </nz-input-group>
                            <ng-template #phoneError let-control>
                                <ng-container *ngIf="control.hasError('required')">Please enter phone number
                                </ng-container>
                                <ng-container *ngIf="control.hasError('pattern')">
                                    Phone number must contain at least 10 characters
                                </ng-container>
                            </ng-template>
                        </nz-form-control>
                    </nz-form-item>
                </div>

                <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="24" nzXl="24"
                    *ngIf="currentSelectedTab != UserTypes.Supplier">
                    <nz-form-item>
                        <nz-form-control [nzErrorTip]="agencyError">
                            <label class="label-text required">Agency</label>
                            <!-- <nz-select nzShowSearch nzPlaceHolder="Select Agency" [nzSize]="'default'"
                                formControlName="agency">
                                <nz-option *ngFor="let agency of listOfAgencies" [nzLabel]="agency.Name"
                                    [nzValue]="agency._id"></nz-option>
                            </nz-select> -->
                            <gs-select #agencySelect [selectData]="listOfAgencies" [showAllCheckbox]="true"
                                [selectPlaceholder]="'Select Agency'" [hideOptionsAfter]="5"
                                [responsiveOptionHiding]="false" [allowMultiSelect]="true"
                                [disabled]="disableAccountsAndSites" (DropDownChanged)="agencyDropDownSelect($event)"
                                [isParentChild]="false" [showSearch]="true"
                                [ngClass]="showAgencysInvalidMessage ? 'redBorder': ''"></gs-select>
                            <p *ngIf="showAgencysInvalidMessage" class="vis-red">Please select at least one agency</p>
                            <ng-template #agencyError let-control>
                                <ng-container *ngIf="control.hasError('required')">Please select agency</ng-container>
                            </ng-template>
                        </nz-form-control>
                    </nz-form-item>
                </div>
                <!-- <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="24" nzXl="24">
                    <nz-form-item>
                        <nz-form-control [nzErrorTip]="accountError">
                            <label class="label-text required">Accounts</label>
                            <gs-select [selectData]="listOfAgencies" [showAllCheckbox]="true" [allowMultiSelect]="true"
                                [isParentChild]="false" [showSearch]="true"
                                [ngClass]="showAccountsInvalidMessage ? 'redBorder': ''"></gs-select>
                            <p *ngIf="showAccountsInvalidMessage" class="vis-red">Please select At Least One Account</p>
                            <ng-template #accountError let-control>
                                <ng-container *ngIf="control.hasError('required')">Please select Accounts</ng-container>
                            </ng-template>
                        </nz-form-control>
                    </nz-form-item>
                </div> -->

                <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="24" nzXl="24"
                    *ngIf="currentSelectedTab == UserTypes.Supplier">
                    <nz-form-item>
                        <nz-form-control [nzErrorTip]="roleError">
                            <label class="label-text required">Role</label>
                            <nz-select nzShowSearch nzPlaceHolder="Select role" [nzSize]="'default'"
                                [nzDisabled]="selectedData && selectedData.roles == 'Super Admin'"
                                formControlName="role" (ngModelChange)="checkIfPayBevRole($event)"
                                [nzSelectOnTab]="true">
                                <nz-option *ngFor="let option of listOfRoles" [nzLabel]="option.name"
                                    [nzValue]="option.id"></nz-option>
                            </nz-select>
                            <ng-template #roleError let-control>
                                <ng-container *ngIf="control.hasError('required')">Please select role</ng-container>
                            </ng-template>
                        </nz-form-control>
                    </nz-form-item>
                </div>

                <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="24" nzXl="24"
                    *ngIf="currentSelectedTab != UserTypes.Supplier">
                    <nz-form-item>
                        <nz-form-control [nzErrorTip]="unitError">
                            <label class="label-text required">{{'Account and Sites'}}</label>
                            <ng-container *ngIf="!isLoadingAccountSites; else accountSitesLoader">
                                <gs-select [parentExplicitSelection]="true" [selectDataParentChild]="sitesData"
                                    [showAllCheckbox]="true"
                                    [selectPlaceholder]="currentSelectedTab != 2 ? 'Select Account and Sites':'Select Supplier and Reps'"
                                    [hideOptionsAfter]="5" [responsiveOptionHiding]="false" [allowMultiSelect]="true"
                                    [isParentChild]="true" [showSearch]="true" [disabled]="disableAccountsAndSites"
                                    (DropDownChanged)="sitesDropdownChanged($event)"
                                    [checkParents]="currentSelectedAccounts"
                                    [ngClass]="showSitesInvalidMessage ? 'redBorder': ''"></gs-select>
                            </ng-container>
                            <ng-template #accountSitesLoader>
                                <nz-skeleton [nzActive]="true" [nzParagraph]="{ rows: 2 }"
                                    [nzAvatar]="false"></nz-skeleton>
                            </ng-template>
                            <p *ngIf="showSitesInvalidMessage" class="vis-red">
                                {{currentSelectedTab != 2 ? 'Please select at least one account and sites':'Please \
                                select at least one supplier and rep'}}</p>
                            <ng-template #unitError let-control>
                                <ng-container *ngIf="control.hasError('required')">
                                    {{currentSelectedTab != 2 ? 'Please select account and sites':'Please select \
                                    supplier and rep'}}</ng-container>
                            </ng-template>
                        </nz-form-control>
                    </nz-form-item>
                </div>

                <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="24" nzXl="24"
                    *ngIf="currentSelectedTab == UserTypes.Supplier && selectedData?.localSupplier">
                    <nz-form-item>
                        <nz-form-control [nzErrorTip]="supplierRepError">
                            <label class="label-text">Company Name</label>
                            <div class="company-name-text">
                                {{ selectedData?.localSupplier?.name ? selectedData?.localSupplier?.name : 'N/A' }}
                            </div>
                        </nz-form-control>
                    </nz-form-item>
                </div>

                <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="24" nzXl="24"
                    *ngIf="currentSelectedTab == UserTypes.Supplier">
                    <nz-form-item>
                        <nz-form-control [nzErrorTip]="supplierRepError">
                            <label class="label-text" [ngClass]="selectedData?.localSupplier ? '' : 'required'">Supplier
                                and Reps</label>
                            <!-- <nz-select nzShowSearch nzPlaceHolder="Select Agency" [nzSize]="'default'"
                                formControlName="agency">
                                <nz-option *ngFor="let agency of listOfAgencies" [nzLabel]="agency.Name"
                                    [nzValue]="agency._id"></nz-option>
                            </nz-select> -->
                            <ng-container *ngIf="!isLoadingSupplierReps; else supplierRepsLoader">
                                <gs-select #supplierSelect [selectDataParentChild]="supplierAndRepsData"
                                    [showAllCheckbox]="true" [selectPlaceholder]="'Select supplier'"
                                    [hideOptionsAfter]="5" [responsiveOptionHiding]="false" [allowMultiSelect]="true"
                                    [moduleToCheckParent]="'User'" (DropDownChanged)="supplierDropdownChanged($event)"
                                    [isParentChild]="true" [parentExplicitSelection]="true"
                                    [checkParents]="currentSelectedRepsSupplier" [showSearch]="true"
                                    [ngClass]="showSuppliersInvalidMessage ? 'redBorder': ''"></gs-select>
                            </ng-container>
                            <ng-template #supplierRepsLoader>
                                <nz-skeleton [nzActive]="true" [nzParagraph]="{ rows: 2 }"
                                    [nzAvatar]="false"></nz-skeleton>
                            </ng-template>
                            <p *ngIf="showSuppliersInvalidMessage" class="vis-red">Please select at least one supplier
                            </p>
                            <ng-template #supplierRepError let-control>
                                <ng-container *ngIf="control.hasError('required')">Please select supplier</ng-container>
                            </ng-template>
                        </nz-form-control>
                    </nz-form-item>
                </div>

                <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="24" nzXl="24"
                    *ngIf="currentSelectedTab == UserTypes.Supplier">
                    <nz-form-item>
                        <nz-form-control [nzErrorTip]="supplierBankError">
                            <label class="label-text">Supplier Bank</label>
                            <ng-container *ngIf="!isLoadingAccountSites; else accountSitesLoader">
                                <gs-select #supplierBankSelect [selectDataParentChild]="supplierBankSitesData"
                                    [showAllCheckbox]="true" [selectPlaceholder]="'Select Account and Sites'"
                                    [hideOptionsAfter]="5" [parentExplicitSelection]="true"
                                    [moduleToCheckParent]="'User'" [responsiveOptionHiding]="false"
                                    [allowMultiSelect]="true" [isParentChild]="true" [showSearch]="true"
                                    (DropDownChanged)="SBsitesDropdownChanged($event)"
                                    [checkParents]="currentSelectedSBAccounts"
                                    [ngClass]="showRepsInvalidMessage ? 'redBorder': ''"></gs-select>
                            </ng-container>
                            <!-- <ng-template #supplierBankSitesLoader>
                                <nz-skeleton [nzActive]="true" [nzParagraph]="{ rows: 2 }"
                                    [nzAvatar]="false"></nz-skeleton>
                            </ng-template> -->
                            <!-- <p *ngIf="showRepsInvalidMessage" class="vis-red">Please select at least one account and
                                sites</p> -->
                            <!-- <ng-template #supplierBankError let-control>
                                <ng-container *ngIf="control.hasError('required')">Please select account and
                                    sites</ng-container>
                            </ng-template> -->
                        </nz-form-control>
                    </nz-form-item>
                </div>

                <div nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="12" nzXl="12"
                    *ngIf="currentSelectedTab == UserTypes.Operator">
                    <nz-form-item class="margin-none">
                        <nz-form-control class="switch-box">
                            <nz-switch formControlName="isChangePasswordRequired"></nz-switch>
                            <label class="switch-label black mr-1">Force change password</label>
                        </nz-form-control>
                    </nz-form-item>
                </div>
                <div nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="12" nzXl="12">
                    <nz-form-item class="margin-none">
                        <nz-form-control class="switch-box">
                            <nz-switch formControlName="isUserActive"></nz-switch>
                            <label class="switch-label black mr-1">Active</label>
                        </nz-form-control>
                    </nz-form-item>
                </div>
                <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="24" nzXl="24"
                    *ngIf="currentSelectedTab != UserTypes.Supplier && assignedAccountsSitesList?.length">
                    <div class="assigned-accounts-sites mt-2">
                        <label class="label-text">Assigned accounts and sites</label>
                        <div class="assigned-list">
                            <div *ngFor="let group of assignedAccountsSitesList" class="account-group">
                                <div class="account-name">{{ group.accountName }}</div>
                                <ul class="site-children" *ngIf="group.sites?.length">
                                    <li *ngFor="let site of group.sites">{{ site.name }}</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="24" nzXl="24"
                    *ngIf="currentSelectedTab == UserTypes.Supplier && assignedSupplierRepsList?.length">
                    <div *ngIf="assignedSupplierRepsList?.length" class="assigned-accounts-sites mt-1">
                        <label class="label-text">Assigned suppliers and reps</label>
                        <div class="assigned-list">
                            <div *ngFor="let group of assignedSupplierRepsList" class="account-group">
                                <div class="account-name">{{ group.parentName }}</div>
                                <ul class="site-children" *ngIf="group.children?.length">
                                    <li *ngFor="let child of group.children">{{ child.name }}</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="24" nzXl="24"
                    *ngIf="currentSelectedTab == UserTypes.Supplier && assignedSupplierBankList?.length">
                    <div class="assigned-accounts-sites mt-1">
                        <label class="label-text">Assigned supplier bank accounts and sites</label>
                        <div class="assigned-list">
                            <div *ngFor="let group of assignedSupplierBankList" class="account-group">
                                <div class="account-name">{{ group.accountName }}</div>
                                <ul class="site-children" *ngIf="group.sites?.length">
                                    <li *ngFor="let site of group.sites">{{ site.name }}</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </ng-container>
    <ng-template #footerTpl>
        <div class="d-flex justify-content-end">
            <div class="d-flex">
                <button nz-button nzType="primary" (click)="handleOk()" [nzLoading]="isLoadingOne"
                    class="medium-btn small-btn width-100 mr-1">{{selectedData != null ? 'Update' : 'Add'}}</button>
                <button nz-button nzType="default" (click)="handleCancel()"
                    class="default-btn width-100">Cancel</button>
            </div>

        </div>
    </ng-template>
</nz-drawer>